const REQUEST_PRODUCT_SOURCE_OPTIONS = 'REQUEST_PRODUCT_SOURCE_OPTIONS';
const REQUEST_PRODUCT_SOURCE_OPTIONS_FAIL = 'REQUEST_PRODUCT_SOURCE_OPTIONS_FAIL';
const REQUEST_PRODUCT_SOURCE_OPTIONS_SUCCESS = 'REQUEST_PRODUCT_SOURCE_OPTIONS_SUCCESS';
const DEFAULT_PRODUCT_SOURCE = 'edx';

export {
  REQUEST_PRODUCT_SOURCE_OPTIONS,
  REQUEST_PRODUCT_SOURCE_OPTIONS_FAIL,
  REQUEST_PRODUCT_SOURCE_OPTIONS_SUCCESS,
  DEFAULT_PRODUCT_SOURCE,
};
